import initialiseLoyaltyPurchasePointsCheckout from 'actions/loyalty/initialiseLoyaltyPurchasePointsCheckout'
import fetchLoyaltyAccount from 'actions/loyalty/fetchLoyaltyAccount'
import LayoutContainer from 'components/Common/LayoutContainer'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { rem } from 'polished'
import { useCallback, useEffect, useMemo } from 'react'
import styled from 'styled-components'
import LoyaltySwitchMembershipRegionPanel from 'loyalty/components/LoyaltySwitchMembershipRegionPanel'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import getLoyaltyAccountRegion from 'loyalty/selectors/getLoyaltyAccountRegion'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import { selectLoggedIn } from 'selectors/accountSelectors'
import LoyaltyPurchasePointsHeroSection from './LoyaltyPurchasePointsHeroSection'
import LoyaltyPurchasePointsPanel from './LoyaltyPurchasePointsPanel'
import LoyaltyPurchasePointsWhatYouNeedToKnow from './LoyaltyPurchasePointsWhatYouNeedToKnow'

const PageBody = styled.div`
  padding: ${rem(48)} 0;
  background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
`

function LoyaltyPurchasePointsPage() {
  const dispatch = useAppDispatch()
  const isLoggedIn = useAppSelector(selectLoggedIn)
  const hasLoyaltyAccount = useAppSelector(getHasLoyaltyAccount)
  const isInLoyaltyRegion = useAppSelector(getIsCurrentRegionUserLoyaltyRegion)
  const loyaltyRegion = useAppSelector(getLoyaltyAccountRegion)
  const userTier = useAppSelector(getLoyaltyDisplayTier)
  const programName = getLoyaltyProgramDisplayName()
  const showRegionSwitchCard = isLoggedIn && hasLoyaltyAccount && !!loyaltyRegion && !isInLoyaltyRegion

  const onContinue = useCallback((offerId: string) => {
    dispatch(initialiseLoyaltyPurchasePointsCheckout(offerId))
  }, [dispatch])

  useEffect(() => {
    if (!isLoggedIn) return

    dispatch(fetchLoyaltyAccount())
  }, [dispatch, isLoggedIn])

  const panel = useMemo(() => {
    if (showRegionSwitchCard) {
      return <LoyaltySwitchMembershipRegionPanel programName={programName} userTier={userTier} standalone />
    }

    return <LoyaltyPurchasePointsPanel onContinue={onContinue} />
  }, [onContinue, programName, showRegionSwitchCard, userTier])

  return <div>
    <LoyaltyPurchasePointsHeroSection panel={panel} />
    <PageBody>
      <LayoutContainer variant="medium">
        <LoyaltyPurchasePointsWhatYouNeedToKnow />
      </LayoutContainer>
    </PageBody>
  </div>
}

export default LoyaltyPurchasePointsPage
